"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Banks = void 0;
var react_1 = __importDefault(require("react"));
var messageContext_1 = require("../../hoc/messageContext");
var useBanks_1 = require("../../hook/useBanks");
var typography_1 = __importDefault(require("antd/es/typography"));
var form_1 = __importDefault(require("antd/es/form"));
var input_1 = __importDefault(require("antd/es/input"));
var button_1 = __importDefault(require("antd/es/button"));
var space_1 = __importDefault(require("antd/es/space"));
var modal_1 = __importDefault(require("antd/es/modal"));
var table_1 = __importDefault(require("antd/es/table"));
var card_1 = __importDefault(require("antd/es/card"));
var icons_1 = require("@ant-design/icons");
var Title = typography_1.default.Title;
var Banks = function () {
    var _a = (0, useBanks_1.useBanks)(), banks = _a.banks, loading = _a.loading, refreshBanks = _a.refreshBanks;
    var _b = (0, messageContext_1.useMessageContext)(), showSuccess = _b.showSuccess, showError = _b.showError;
    var form = form_1.default.useForm()[0];
    var _c = react_1.default.useState(false), isModalVisible = _c[0], setIsModalVisible = _c[1];
    var _d = react_1.default.useState(null), editingBank = _d[0], setEditingBank = _d[1];
    var _e = react_1.default.useState(false), submitLoading = _e[0], setSubmitLoading = _e[1];
    var handleAdd = function () {
        setEditingBank(null);
        form.resetFields();
        setIsModalVisible(true);
    };
    var handleEdit = function (record) {
        setEditingBank(record);
        form.setFieldsValue(record);
        setIsModalVisible(true);
    };
    var handleDelete = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, fetch("".concat(process.env.REACT_APP_BASE_URL, "/banks/").concat(id), {
                            method: 'DELETE',
                        })];
                case 1:
                    response = _a.sent();
                    if (response.ok) {
                        showSuccess('Банк успешно удален');
                        refreshBanks();
                    }
                    else {
                        showError('Ошибка при удалении банка');
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    showError('Ошибка при удалении банка');
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleSubmit = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var method, url, response, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setSubmitLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    method = editingBank ? 'PATCH' : 'POST';
                    url = editingBank
                        ? "".concat(process.env.REACT_APP_BASE_URL, "/banks/").concat(editingBank.id)
                        : "".concat(process.env.REACT_APP_BASE_URL, "/banks");
                    return [4 /*yield*/, fetch(url, {
                            method: method,
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({
                                bank: values,
                            }),
                        })];
                case 2:
                    response = _a.sent();
                    if (response.ok) {
                        showSuccess("\u0411\u0430\u043D\u043A \u0443\u0441\u043F\u0435\u0448\u043D\u043E ".concat(editingBank ? 'обновлен' : 'добавлен'));
                        setIsModalVisible(false);
                        refreshBanks();
                    }
                    else {
                        showError("\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 ".concat(editingBank ? 'обновлении' : 'добавлении', " \u0431\u0430\u043D\u043A\u0430"));
                    }
                    return [3 /*break*/, 5];
                case 3:
                    error_2 = _a.sent();
                    showError("\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 ".concat(editingBank ? 'обновлении' : 'добавлении', " \u0431\u0430\u043D\u043A\u0430"));
                    return [3 /*break*/, 5];
                case 4:
                    setSubmitLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var expandedRowRender = function (record) {
        var programColumns = [
            {
                title: 'ID',
                dataIndex: 'id',
                key: 'id',
                width: 80,
            },
            {
                title: 'Название программы',
                dataIndex: 'program_name',
                key: 'program_name',
            },
            {
                title: 'Процентная ставка',
                dataIndex: 'interest_rate',
                key: 'interest_rate',
                render: function (rate) { return "".concat(rate, "%"); },
            },
            {
                title: 'Дата создания',
                dataIndex: 'created_at',
                key: 'created_at',
                render: function (date) { return new Date(date).toLocaleDateString(); },
            },
        ];
        return (react_1.default.createElement(card_1.default, { title: "\u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B \u0431\u0430\u043D\u043A\u0430", style: { marginBottom: 16 } },
            react_1.default.createElement(table_1.default, { columns: programColumns, dataSource: record.programs, rowKey: "id", pagination: false })));
    };
    var columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            width: 80,
            sorter: function (a, b) { return a.id - b.id; },
        },
        {
            title: 'Название',
            dataIndex: 'name',
            key: 'name',
            sorter: function (a, b) { return a.name.localeCompare(b.name); },
        },
        {
            title: 'Страна',
            dataIndex: 'country',
            key: 'country',
            sorter: function (a, b) { return a.country.localeCompare(b.country); },
        },
        {
            title: 'Количество программ',
            key: 'programs_count',
            render: function (_, record) { return record.programs.length; },
        },
        {
            title: 'Действия',
            key: 'actions',
            width: 120,
            render: function (_, record) { return (react_1.default.createElement(space_1.default, null,
                react_1.default.createElement(button_1.default, { icon: react_1.default.createElement(icons_1.EditOutlined, null), onClick: function () { return handleEdit(record); } }),
                react_1.default.createElement(button_1.default, { icon: react_1.default.createElement(icons_1.DeleteOutlined, null), danger: true, onClick: function () { return handleDelete(record.id); } }))); },
        },
    ];
    return (react_1.default.createElement(card_1.default, null,
        react_1.default.createElement(Title, { level: 1 }, "\u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0431\u0430\u043D\u043A\u0430\u043C\u0438"),
        react_1.default.createElement("div", { style: { marginBottom: 16 } },
            react_1.default.createElement(button_1.default, { type: "primary", icon: react_1.default.createElement(icons_1.PlusOutlined, null), onClick: handleAdd }, "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0431\u0430\u043D\u043A")),
        react_1.default.createElement(table_1.default, { dataSource: banks, columns: columns, rowKey: "id", loading: loading, expandable: {
                expandedRowRender: expandedRowRender,
                expandRowByClick: true,
            }, pagination: {
                pageSize: 10,
                showSizeChanger: true,
                showTotal: function (total) { return "\u0412\u0441\u0435\u0433\u043E: ".concat(total, " \u0437\u0430\u043F\u0438\u0441\u0435\u0439"); },
            } }),
        react_1.default.createElement(modal_1.default, { title: "".concat(editingBank ? 'Редактировать' : 'Добавить', " \u0431\u0430\u043D\u043A"), open: isModalVisible, onCancel: function () { return setIsModalVisible(false); }, footer: null },
            react_1.default.createElement(form_1.default, { form: form, onFinish: handleSubmit, layout: "vertical" },
                react_1.default.createElement(form_1.default.Item, { name: "name", label: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435", rules: [{ required: true, message: 'Введите название банка' }] },
                    react_1.default.createElement(input_1.default, null)),
                react_1.default.createElement(form_1.default.Item, { name: "country", label: "\u0421\u0442\u0440\u0430\u043D\u0430", rules: [{ required: true, message: 'Введите страну' }] },
                    react_1.default.createElement(input_1.default, null)),
                react_1.default.createElement(form_1.default.Item, null,
                    react_1.default.createElement(space_1.default, null,
                        react_1.default.createElement(button_1.default, { type: "primary", htmlType: "submit", loading: submitLoading }, editingBank ? 'Сохранить' : 'Добавить'),
                        react_1.default.createElement(button_1.default, { onClick: function () { return setIsModalVisible(false); } }, "\u041E\u0442\u043C\u0435\u043D\u0430")))))));
};
exports.Banks = Banks;
